import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import Main from './components/Main.component';
import { Link } from "react-router-dom";
import './App.css';


function App() {

      const [showMobileNav, setShowMobileNav] = useState(false);

    function toggleNavMenu(){
        setShowMobileNav(!showMobileNav);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      };

  return (
    <div className="App blur" id="App">
      <div className="mobile-nav-icon" id="mobile-nav-icon">	
        <div style={{float:'left',paddingLeft:'20px'}}>
          <img alt="Camgirl Crawler mobile logo" title="Camgirl Crawler mobile logo" src="images/logo_mobile.gif" width={'81px'} height={'84px'}/>
        </div>
        <div onClick={toggleNavMenu} style={{float:'right',padding:'20px'}}>
          <img alt="Camgirl Crawler mobile menu toggle" src={showMobileNav ? 'images/menu_close.gif' : 'images/menu_open.gif'}  width={'50px'} height={'50px'}/>
        </div>
		  </div>
        <div className="topMenu">
          <div style={{display: 'inline-block',marginTop:0}}> <Link to={`/`}><p>CamgirlCrawler</p></Link></div>
          <div id="logo">
            <img src="/images/logo.gif" alt="Camgirl Crawler logo" title="Camgirl Crawler logo"  width={'95px'} height={'95px'}/>
          </div>       
        </div>
        <div className="topMenuNav">
            <Link  to={`/camgirl-hot-deals`}>HOT DEALS🔥</Link>
            <Link  to={`/`}>CAMGIRL SEARCH</Link>
            <a href='new-hot-camgirl-blog.html'>BLOG</a>
            <a href='best-cam-sites-review.html'>REVIEWS</a>
        </div>  
        <Main /> 
        {showMobileNav && (
        <div className="mobile-nav-container" id="mobile-nav-container" style={{display: showMobileNav? 'block': 'none'}}>  
          <div>
              <ul className="mobile-nav_list">         
                    <li className="mobile-nav_list-item">
                        <a  href="/camgirl-hot-deals">Hot Deals🔥</a>
                    </li>
                    {/* <li className="mobile-nav_list-item">
                        <a href="/">Face Search</a>
                    </li> */}
                    <li className="mobile-nav_list-item">
                        <a href="/">Camgirl Search</a>
                    </li>
                    {/* <li className="mobile-nav_list-item">
                        <a  href="/camgirl-facial-recognition-search-guide.html">Search Guide</a>
                    </li> */}
                    <li className="mobile-nav_list-item">
                        <a  href="/new-hot-camgirl-blog.html">Blog</a>
                    </li>
                    <li className="mobile-nav_list-item">
                        <a  href="/best-cam-sites-review.html">Reviews</a>
                    </li>
                </ul>  
          </div>
        </div>     
        )}
      </div>
  );
}
export default App;